<template>
  <!-- 结构对齐 site-112 AnCore/Wf/Todo.html -->
  <div class="col-sm-12" style="height: 100%;" v-loading="loading" @click="menuOpen = false">
    <!-- 原版 topBar 即使无「新建」也有搜索行高度；pull-right 浮动需 clearfix，否则高度塌成 0 -->
    <div data-id="topBar" class="clearfix" style="min-height: 28px;">
      <div
        v-if="canCreate"
        class="dropdown"
        :class="{ open: menuOpen }"
        style="display: inline-block;"
        @click.stop
      >
        <button
          class="btn btn-primary btn-xs dropdown-toggle"
          type="button"
          aria-haspopup="true"
          :aria-expanded="menuOpen ? 'true' : 'false'"
          @click.stop="menuOpen = !menuOpen"
        >
          <i class="iconfont icon-add" />新建
          <span class="caret" />
        </button>
        <ul
          v-show="menuOpen"
          class="dropdown-menu"
          style="padding-top: 8px; overflow: auto;"
        >
          <template v-for="(m, i) in models">
            <li :key="m.modelId">
              <a href="javascript:;" @click.prevent="onNew(m.path)">{{ m.modelName }}</a>
            </li>
            <li
              v-if="i < models.length - 1"
              :key="'d-' + m.modelId"
              role="separator"
              class="divider"
            />
          </template>
        </ul>
      </div>

      <div class="input-group has-feedback form-inline pull-right">
        <input
          class="form-control"
          v-model="keyword"
          placeholder=""
        />
        <span class="fa fa-search form-control-feedback" aria-hidden="true" />
      </div>
    </div>

    <hr style="margin: 10px 0;" />

    <div class="clearfix" style="height: 25px;" data-id="todoHeader" :style="{ paddingRight: scrollbarPad + 'px' }">
      <div class="hidden-xs">
        <div class="text-center pull-left anCore-text-overflow" style="width: 50%;">业务名称</div>
        <div class="pull-left" style="width: 50%;">
          <div class="pull-left anCore-text-overflow" style="width: 20%;">当前位置</div>
          <div class="pull-left anCore-text-overflow" style="width: 15%;">相关表</div>
          <div class="pull-left anCore-text-overflow" style="width: 14%;">提交人</div>
          <div class="pull-left anCore-text-overflow" style="width: 20%;">收件时间</div>
          <div class="pull-left anCore-text-overflow" style="width: 14%;">创建人</div>
          <div class="pull-left anCore-text-overflow" style="width: 17%;">创建时间</div>
        </div>
      </div>
      <div class="visible-xs">
        <div class="pull-left anCore-text-overflow" style="width: calc(100% - 65px);">业务名称</div>
        <div class="pull-left anCore-text-overflow" style="width: 62px;">收件时间</div>
      </div>
    </div>

    <div
      ref="todoCasePanel"
      data-id="todoCasePanel"
      class="clearfix"
      style="height: calc(100% - 75px); overflow: auto; clear: both;"
    >
      <div v-for="g in filteredGroups" :key="g.key">
        <div class="anCore-groupPanel-heading" @click="toggle(g)">
          <i class="fa fa-sort-desc" :class="{ 'fa-rotate-270': !g.expand }" />
          <span>{{ g.key }}</span>
          <span>({{ g.items.length }})</span>
        </div>
        <div v-show="g.expand">
          <div
            v-for="row in g.items"
            :key="row.id"
            class="list-group-item anCore-groupPanel-item"
            :style="{ fontWeight: row.unread ? 'bold' : 'normal' }"
            @click="openCase(row)"
          >
            <div class="hidden-xs">
              <div class="pull-left anCore-text-overflow" style="width: 50%;">
                <a href="javascript:void(0);" style="color: inherit;">{{ row.caseName }}</a>
              </div>
              <div class="pull-left" style="width: 50%;">
                <div class="pull-left anCore-text-overflow" style="width: 20%; min-height: 25px;">
                  <span>{{ row.nodeName }}</span>
                </div>
                <div class="pull-left anCore-text-overflow" style="width: 15%; min-height: 25px;">
                  <span class="text-muted">{{ row.relatedForms || '—' }}</span>
                </div>
                <div class="pull-left anCore-text-overflow" style="width: 14%; min-height: 25px;">
                  <span>{{ row.prevUser }}</span>
                </div>
                <div class="pull-left anCore-text-overflow" style="width: 20%; min-height: 25px;">
                  <span>{{ fmtDate(row.receiveDate) }}</span>
                </div>
                <div class="pull-left anCore-text-overflow" style="width: 14%; min-height: 25px;">
                  <span>{{ row.creater }}</span>
                </div>
                <div class="pull-left anCore-text-overflow" style="width: 17%; min-height: 25px;">
                  <span>{{ fmtDate(row.createDate) }}</span>
                </div>
              </div>
            </div>
            <div class="visible-xs">
              <div class="pull-left anCore-text-overflow" style="width: calc(100% - 65px);">
                <a href="javascript:void(0);" style="color: inherit;">{{ row.caseName }}</a>
              </div>
              <div class="pull-left text-right anCore-text-overflow" style="width: 62px; min-height: 25px;">
                <span>{{ fmtDate(row.receiveDate) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="!loading && !filteredGroups.length">
        <div class="text-center text-muted todo-empty">
          <div style="padding: 24px 0 12px;">没有我的待办业务</div>
          <div class="todo-empty-hint">待办只显示需要你处理的事项；查历史项目表单请走下面入口</div>
          <div class="todo-empty-actions">
            <el-button v-if="canCreate" type="primary" size="small" @click="onNew('/entrust/new')">新建委托</el-button>
            <el-button v-if="isOfficeUser" size="small" @click="go('/task-track')">任务监控（查项目）</el-button>
            <el-button v-if="isOfficeUser" size="small" @click="go('/soil/handover')">样品管理（056）</el-button>
            <el-button v-if="isFieldUser" size="small" @click="go('/pick/batch-contract')">批量现场采样</el-button>
            <el-button v-if="isFieldUser" size="small" @click="go('/home/field')">现场部工作台</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NEW_CASE_MODELS } from '@/config/ivanMenus'
import { fetchTodoRows } from '@/utils/todoAdapter'
import { subscribeTodoSync } from '@/utils/todoSync'
import { isAdmin, isTaskDispatcher, isFieldDirector, isOfficeDirector } from '@/utils/user'

export default {
  name: 'TodoBox',
  data() {
    return {
      loading: false,
      groups: [],
      keyword: '',
      menuOpen: false,
      models: NEW_CASE_MODELS,
      scrollbarPad: 0,
      // 注意：Vue2 不会把 _/$ 开头的 data 代理到 this，禁止用 _reloadSeq
      reloadSeq: 0,
      /** keep-alive 首次 mounted+activated 双触发，跳过一次 */
      skipActivateReload: true
    }
  },
  computed: {
    canCreate() {
      return isAdmin() || isTaskDispatcher()
    },
    isOfficeUser() {
      return isAdmin() || isOfficeDirector() || isTaskDispatcher()
    },
    isFieldUser() {
      return isAdmin() || isFieldDirector()
    },
    filteredGroups() {
      const kw = (this.keyword || '').trim().toLowerCase()
      if (!kw) return this.groups
      return this.groups
        .map(g => ({
          ...g,
          items: g.items.filter(r =>
            String(r.caseName).toLowerCase().includes(kw) ||
            String(r.nodeName).toLowerCase().includes(kw)
          )
        }))
        .filter(g => g.items.length)
    }
  },
  async mounted() {
    this.menuOpen = false
    document.addEventListener('click', this.onDocClick)
    window.addEventListener('resize', this.syncScrollbarPad)
    // 先完成首次加载再订阅读秒，避免 silent 重拉顶掉 reloadSeq 后 loading 永不清
    await this.reload()
    this.startAutoRefresh()
  },
  async activated() {
    this.menuOpen = false
    if (this.skipActivateReload) {
      this.skipActivateReload = false
      this.startAutoRefresh()
      return
    }
    await this.reload({ silent: true })
    this.startAutoRefresh()
  },
  deactivated() {
    this.stopAutoRefresh()
  },
  beforeDestroy() {
    this.stopAutoRefresh()
    document.removeEventListener('click', this.onDocClick)
    window.removeEventListener('resize', this.syncScrollbarPad)
  },
  methods: {
    onDocClick() {
      this.menuOpen = false
    },
    syncScrollbarPad() {
      const el = this.$refs.todoCasePanel
      if (!el) return
      const w = el.offsetWidth - el.clientWidth
      this.scrollbarPad = w > 0 ? w : 0
    },
    startAutoRefresh() {
      this.stopAutoRefresh()
      // App 提交 / 审核完成 → pulse rev 变 → 立刻重拉列表，角标由 Layout 同步增减
      this._unsubTodo = subscribeTodoSync(() => {
        this.reload({ silent: true })
      })
    },
    stopAutoRefresh() {
      if (typeof this._unsubTodo === 'function') {
        this._unsubTodo()
        this._unsubTodo = null
      }
    },
    async reload(opts = {}) {
      const silent = !!(opts && opts.silent)
      const seq = ++this.reloadSeq
      if (!silent) this.loading = true
      try {
        const rows = await fetchTodoRows()
        if (seq === this.reloadSeq) this.groups = Array.isArray(rows) ? rows : []
      } catch (e) {
        if (seq === this.reloadSeq) {
          const msg = (e && e.message) || '待办加载失败'
          if (!silent) {
            if (this.$message) this.$message.error(msg)
            else console.error('[TodoBox]', msg, e)
          }
        }
      } finally {
        // 只要是当前最新一次请求结束，就必须关转圈（含 silent）。
        // 否则：非 silent 进行中又被 pulse 触发 silent → reloadSeq 前进，
        // 旧请求 finally 因 seq 不匹配跳过，loading 会一直 true。
        if (seq === this.reloadSeq) {
          this.loading = false
          this.$nextTick(() => this.syncScrollbarPad())
        }
      }
    },
    toggle(g) {
      this.$set(g, 'expand', !g.expand)
      this.$nextTick(() => this.syncScrollbarPad())
    },
    onNew(path) {
      this.menuOpen = false
      this.$router.push(path).catch(() => {})
    },
    go(path) {
      this.$router.push(path).catch(() => {})
    },
    openCase(row) {
      this.menuOpen = false
      // 采样审核 / 采样任务管理：走服务端 route（批量现场采样 / 审核页），勿改道任务监控
      if (row.xmbh && row.nodeName === '样品管理') {
        this.$router.push({ path: '/soil/handover', query: { xmbh: row.xmbh } }).catch(() => {})
        return
      }
      if (row.xmbh && row.nodeName === '任务派遣') {
        this.$router.push({ path: '/task-track', query: { xmbh: row.xmbh } }).catch(() => {})
        return
      }
      if (!row.route) return
      const r = String(row.route)
      const qi = r.indexOf('?')
      if (qi >= 0) {
        const path = r.slice(0, qi)
        const query = {}
        r.slice(qi + 1).split('&').forEach(pair => {
          if (!pair) return
          const eq = pair.indexOf('=')
          const k = eq >= 0 ? pair.slice(0, eq) : pair
          const v = eq >= 0 ? pair.slice(eq + 1) : ''
          if (k) query[decodeURIComponent(k)] = decodeURIComponent(v || '')
        })
        this.$router.push({ path, query }).catch(() => {})
        return
      }
      this.$router.push(r).catch(() => {})
    },
    fmtDate(v) {
      if (!v) return ''
      const s = String(v)
      if (s.length >= 16) return s.slice(0, 16).replace('T', ' ')
      return s.slice(0, 10)
    }
  }
}
</script>

<style scoped>
.todo-empty-hint {
  font-size: 13px;
  margin-bottom: 16px;
  padding: 0 24px;
  line-height: 1.6;
}
.todo-empty-actions .el-button {
  margin: 4px 6px;
}
</style>
